import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);
export const useBranding = () => useContext(BrandingContext);

const DEFAULT = {
  product_name: "BCS Seat-to-Sale",
  company_name: "Colosseum Legacy",
  logo_text: "Colosseum Legacy",
  primary_color: "#EF4444",
  accent_color: "#10B981",
  currency: "USD",
  currency_symbol: "$",
  target: "sportclips",
  login_image: "",
  login_headline: "",
  login_subtext: "",
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  const apply = useCallback((b) => {
    setBranding(b);
    document.documentElement.style.setProperty("--brand", b.primary_color);
    document.documentElement.style.setProperty("--brand-accent", b.accent_color);
  }, []);

  const refresh = useCallback(() => {
    api.get("/branding").then((res) => apply(res.data)).catch(() => {});
  }, [apply]);

  useEffect(() => { refresh(); }, [refresh]);

  const money = useCallback(
    (n) => `${branding.currency_symbol}${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
    [branding.currency_symbol]
  );

  // Country-aware formatter: used where a single network spans currencies
  // (e.g. Just Cuts = Australia A$ + Ontario C$). Falls back to the network symbol.
  const moneyFor = useCallback(
    (n, cc) => {
      const CC_SYMBOL = { US: "$", CA: "C$", AU: "A$", NZ: "NZ$" };
      const sym = (cc && CC_SYMBOL[cc]) || branding.currency_symbol;
      return `${sym}${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    },
    [branding.currency_symbol]
  );

  return (
    <BrandingContext.Provider value={{ branding, apply, refresh, money, moneyFor }}>
      {children}
    </BrandingContext.Provider>
  );
}
